import { IntegrationStepResponseDto } from './integration-step-response.dto';

export class IntegrationStatusResponseDto {
  appId: string;

  steps: IntegrationStepResponseDto[];
}
